import Component from '../core/Component';
import $ from 'jquery';

export default class ToggleClass extends Component
{
    constructor($element)
    {
        super($element)
        if (this.element.dataset.target == 'this') {
            this.target = this.element
        } else if (this.element.dataset.target.indexOf('#') != -1) {
            this.target = document.querySelector(this.element.dataset.target)
        } else {
            this.target = this.$element.closest(this.element.dataset.target)[0];
        }
        this.classname = 'is-active'

        if (this.element.dataset.classname) {
            this.classname = this.element.dataset.classname
        }
    }

    prepare()
    {
        console.log(window.location.hash.replace('#', ''))
        if (this.target.id == window.location.hash.replace('#', '') && window.location.hash.replace('#', '') != '') {
            // tracking
            if (this.element.dataset.target != '' && this.element.dataset.target != null && !this.target.classList.contains(this.classname)) {
                $.get(this.element.dataset.href)
            }

            this.target.classList.add(this.classname)
        }

        this.element.addEventListener('click', event => {
            // tracking
            if (this.element.dataset.target != '' && this.element.dataset.target != null && !this.target.classList.contains(this.classname)) {
                $.get(this.element.dataset.href)
            }

            var isOpened = $(this.target).hasClass(this.classname)

            if (this.element.dataset.close != '') {
                $(this.element.dataset.close).removeClass(this.classname)
            }

            if (isOpened) {
                this.target.classList.remove(this.classname)
            } else {
                this.target.classList.add(this.classname)
            }
        })
    }
}


// WEBPACK FOOTER //
// ./components/ToggleClass.js